import styled from 'styled-components';

import { ContentContainer } from '@riac/design-system';
import { OpenSeaDragon } from '@riac/design-system';
import { PageTabsBody } from '@riac/design-system';
import { MarkdownContentArea } from '@riac/design-system';
import { Input, InputControl } from '@riac/design-system';
import { Label } from '@riac/design-system';
import { BoxButton, Button, TextButton } from '@riac/design-system';

export const DetailPageContainer = styled.div`
  ${PageTabsBody} {
    background: ${(props) => props.theme.black[10]};
    *:not(a) {
      color: ${(props) => props.theme.black[100]};
    }
  }
  ${MarkdownContentArea} * {
    a {
      color: ${(props) => props.theme.black[100]};
      text-decoration: underline;
    }
  }
`;

export const DetailPageMobileHeadlineSection = styled.div`
  flex-direction: column;
  padding: 0 15px;

  h1 {
    line-height: 0.95;
    font-size: 2.5rem;
    margin-bottom: 0.5rem;

    @media print {
      color: ${(props) => props.theme.black[95]};
      font-size: 2.4rem;
      margin-bottom: 5px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0.5rem;
    line-height: 1.2;
    font-family: ${({ theme }) => theme.sansSerif};
    font-variant: none;

    color: rgba(255, 255, 255, 0.7);

    @media print {
      color: ${(props) => props.theme.black[50]};
      font-size: 1.6rem;
      margin-bottom: 5px;
    }
  }

  h3 {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 0.5rem;
    font-family: ${({ theme }) => theme.sansSerif};
    font-variant: none;

    @media print {
      color: ${(props) => props.theme.black[50]};
      font-size: 1.4rem;
      margin-bottom: 10px;
    }
  }


  ${({ theme }) => theme.tablet}
  {
    h1 {
      font-size: 3.8rem;
      margin-bottom: 1rem;
    }
    
    h2 {
      font-weight: 500;
      font-size: 2.2rem;
      margin-bottom: 1rem;
    }
    
    h3 {
      font-weight: 500;
      font-size: 2.6rem;
      margin-bottom: 1rem;
    }
  }

  ${({ theme }) => theme.desktop}{
    display: none;
  }
`;

export const DetailPageHeadlineSection = styled.div`
  display: none;
  flex-direction: column;

  h1 {
    line-height: 0.95;
    font-size: 3.8rem;
    margin-bottom: 1rem;

    @media print {
      color: ${(props) => props.theme.black[95]};
      font-size: 2.4rem;
      margin-bottom: 5px;
    }
  }

  h2 {
    font-weight: 500;
    font-size: 16px;
    font-size: 2.2rem;
    margin-bottom: 1rem;
    font-family: ${({ theme }) => theme.sansSerif};
    font-variant: none;

    color: rgba(255, 255, 255, 0.7);

    @media print {
      color: ${(props) => props.theme.black[50]};
      font-size: 1.6rem;
      margin-bottom: 5px;
    }
  }

  h3 {
    font-weight: 500;
    font-size: 2.6rem;
    margin-bottom: 1rem;
    color: rgba(255, 255, 255, 0.85);
    font-family: ${({ theme }) => theme.sansSerif};
    font-variant: none;

    @media print {
      color: ${(props) => props.theme.black[50]};
      font-size: 1.4rem;
      margin-bottom: 10px;
    }
  }

  ${({ theme }) => theme.desktop} {
    display: flex;
  }

  ${({ theme }) => theme.widescreen} {
    h1 {
      font-size: 4.8rem;
    }

    h2 {
      font-size: 2.6rem;
    }
  }
`;

export const DetailPageMainSection = styled.div`
  display: flex;
  flex-flow: column;

  padding: 30px 0;
  background-color: rgba(255, 255, 255, 0.075);

  @media print {
    padding: 0;
  }

  ${ContentContainer} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;

    width: 100%;

    &>div {
      flex: 1;
      flex-shrink: 0;
      width: 100%;
      min-width: 100%;
      margin: 12px 0;

      ${(props) => props.theme.phone} {
        padding-left: 10px;
        min-width: 430px;
      }
    }
    &>div:first-child {
      ${(props) => props.theme.phone} {
        padding-right: 10px;
        padding-left: 0;
      }
      flex: 1;

      @media print {
        display:grid;
        grid-template-columns: 1fr 1fr;
      }
    }
  }
`;

export const DetailPageOpenSeaDragonRatioWrapper = styled.div`
  background: white;
  box-sizing: border-box;
  overflow: auto;
  max-width: 100%;

  @media print {
    max-width: 400px;
    width: 100%;
    height:300px;
    margin: 0 auto;
  }
`;

export const DetailPageVideoWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding-bottom: 65%;
  position: relative;
  margin: 0;

  & > iframe {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    width: 100%;
    height: 100%;
  }
`;

export const DetailPageOpenSeaDragonViewer = styled(OpenSeaDragon)`
  width: 100%;
  max-width: 100%;
  padding-bottom: 65%;
  position: relative;
  margin: 0;

  #osd {
    position: absolute!important; /** Important needed due to OSD library applying relative on element.style. */
    top: 0; bottom: 0; left: 0; right: 0;
    height: auto;
  }
`;

export const DetailPageEstimatedPrice = styled.div`
  font-size: 16px;
  margin-bottom: 0.125rem;
  color: rgba(255, 255, 255, 0.95);

  ${({ theme }) => theme.tablet} {
    font-size: 2.5rem;
    margin: 2rem 0px 0px;
  }

  @media print {
    color: ${(props) => props.theme.black[50]};
    font-size: 1.6rem;
  }
  &>img {
    vertical-align: middle;
  }
`;

export const DetailsPageDetailRichDescriptionHeader = styled.h3`
  text-align: center;
  width: 100%;
`;

export const DetailsPageRelatedItemsTitle = styled.h2`
  @media print {
    display: none;
  }
`;

export const DetailsPageRelatedItem = styled.div`
  padding: 0;
  padding-top: 0.5em;

  ${(props) => props.theme.tablet} {
    padding: 40px;
  }

  @media print {
    padding: 0;
  }

  img {
    max-width: 256px;
    align-self: center;
    margin-bottom: 10px;

    @media print {
      max-width: 100%;
    }
  }
  ${Button} {
    display: flex;
    flex-direction: column;
  
    position: relative;

    h4 {
      text-align: center;
      
      @media print {
        color: ${(props) => props.theme.black[50]};
      }
    }
    &:hover > h4 {
      color: ${({ theme }) => theme.gold[50]}
    }
  }
`;

export const DetailsPageRelatedItems = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 30px;
  width: 100%;
  padding: 0;

  ${(props) => props.theme.tablet} {
    grid-template-columns: 1fr 1fr;
    padding: 10px 40px 40px;
  }

  ${(props) => props.theme.widescreen} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media print {
    display: none;
  }
  
  img {
    background-color: white;
  }
`;

export const InputErrorContainer = styled.div`
  max-width: 800px;
  text-align: center;
  margin: 50px auto 100px;
  display: flex;
  flex-wrap: wrap;

  > * {
    width: 100%;
  }

  > p {
    margin: 20px 0;
  }

  ${Label} {
    max-width: 300px;
    margin: 30px auto 0;
  }
`;

export const GoToLotContainer = styled.div`
  display: flex;
  align-items: stretch;

  ${({ theme }) => theme.desktop} {
    width: 40%;
    margin: auto;
  }
`;

export const GoToLotInput = styled(Input)`
  flex: 1 1 60%;
  text-align: center;
  align-items: stretch;

  align-self: center;

  ${InputControl} {
    text-align: center;
    line-height: 1;
  }

  ${BoxButton} {
    padding: 0 0.5em;
    height: 100%;
  }

  ${({ theme }) => theme.desktop} {
    flex: 0 1 50%;
  }
`;

export const GoToLotIncrementer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  flex: 1 1 20%;

  ${TextButton} {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  ${({ theme }) => theme.desktop} {
    flex: 1 0 25%;
  }
`;

export const GoToLotIncrementerLotLabel = styled.div`
  display: none;
  
  ${({ theme }) => theme.phone} {
    display: block;
  }
`;

export const CatalogViewLinkContainer = styled.div`
  ${TextButton} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TermsAndConditions = styled.div`
  p, div, ol, ul, figure  {
    ${(props) => props.theme.tablet} {
      max-width: max-content;
      padding: 30px 60px;
    }
  } 
`;
